import styles from './styles.module.css';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import DataTable from 'components/utils/DataTable';
import { Grid, Button, Chip, IconButton } from '@mui/material';
import { TRANSFER_STATUS, STATUS_COLOR_MAPPING } from 'const';
import { InventoryContext } from 'Context/InventoryContext';
import { WarehouseContext } from 'Context/WarehouseContext';
import Loader from 'components/utils/Loading';
import StockTransferService from 'services/StockTransferService';
import { AlertMessagesContext } from 'react-alert-messages';

export default function InternalStockTransferDetailsPopup(props) {
  const { postAlertMessage } = useContext(AlertMessagesContext);

  const { t: tCommon } = useTranslation('common');
  const { getProducts, getStockBatches } = useContext(InventoryContext);
  const { getWarehouseProducts } = useContext(WarehouseContext);
  const { handleClose, transferData, handleSuccess } = props;

  const [isLoading, setIsLoading] = useState(false);

  const listHeader = [
    { id: 'plu', label: tCommon('PLU'), type: 'text' },
    { id: 'name', label: tCommon('Item Name'), type: 'text' },
    { id: 'quantity', label: tCommon('Quantity'), type: 'text' },
  ];

  const handleAcceptTransfer = async () => {
    setIsLoading(true);
    try {
      await StockTransferService.updateInternalStockTransfer(transferData.id, {
        status: 'RECEIVED'
      });
      getProducts({ useCache: false });
      getStockBatches({ useCache: false });
      getWarehouseProducts({ useCache: false });
      postAlertMessage({ text: tCommon('Stock transfer accepted successfully'), type: 'success' });
      handleSuccess();
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setIsLoading(false);
  };

  const handleRejectTransfer = async () => {
    setIsLoading(true);
    try {
      await StockTransferService.updateInternalStockTransfer(transferData.id, {
        status: 'REJECTED'
      });
      getProducts({ useCache: false });
      getStockBatches({ useCache: false });
      getWarehouseProducts({ useCache: false });
      postAlertMessage({ text: tCommon('Stock transfer rejected successfully'), type: 'success' });
      handleSuccess();
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setIsLoading(false);
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Internal Stock Transfer Details')}</h2>
          <IconButton onClick={handleClose}><CloseIcon/></IconButton>
        </div>
        <div className={styles.detailsWrapper}>
          {isLoading ? (
            <div className={styles.loadingContainer}>
              <Loader isOpen={true} backdropColor={'#ffffff'} />
            </div>
          ) : (
            <>
              {transferData?.status === 'TRANSIT' && (
                <div className={styles.customerDetails}>
                  <Grid container spacing={1} sx={{ ml: 1.25, mr: 1.25 }}>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        className={styles.draftBtn}
                        variant="outlined"
                        color="error"
                        onClick={() => handleRejectTransfer()}
                      >
                        {tCommon('Reject Transfer')}
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        className={styles.draftBtn}
                        variant="outlined"
                        onClick={() => handleAcceptTransfer()}
                      >
                        {tCommon('Accept Transfer')}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              )}
              <div className={styles.customerDetails}>
                <div>
                  <h3 className={styles.editTitle}>{tCommon('From Warehouse')}</h3>
                  <h3 className={styles.customerData}>{transferData?.from_warehouse?.name || '-'}</h3>
                </div>
                <div>
                  <h3 className={styles.editTitle}>{tCommon('To Warehouse')}</h3>
                  <h3 className={styles.customerData}>{transferData?.to_warehouse?.name || '-'}</h3>
                </div>
                <div>
                  <h3 className={styles.editTitle}>{tCommon('Status')}</h3>
                  <h3 className={styles.customerData}>
                    <Chip
                      className={styles.chip}
                      label={TRANSFER_STATUS[transferData?.status]}
                      color={STATUS_COLOR_MAPPING[transferData?.status] || 'default'}
                      size="small"
                    />
                  </h3>
                </div>
              </div>
              {transferData?.data?.remark && (
                <Grid container spacing={1} className={styles.subSection}>
                  <Grid item xs={3} className={styles.subSectionHeader}>
                    <h6 className={styles.textHead}>{tCommon('Remark')}</h6>
                  </Grid>
                  <Grid item xs={9}>
                    <h6 className={styles.textValues}>{transferData?.data?.remark}</h6>
                  </Grid>
                </Grid>
              )}
              <div className={styles.tableContent1}>
                <DataTable
                  columns={listHeader}
                  rows={transferData?.data?.items || []}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
